/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { registrationsControllerCheckSso } from "./registrationsControllerCheckSso";
import { registrationsControllerGetCompanyRoles } from "./registrationsControllerGetCompanyRoles";
import { registrationsControllerNormalizeEmail } from "./registrationsControllerNormalizeEmail";

export function registrationsService() {
  return { registrationsControllerCheckSso, registrationsControllerNormalizeEmail, registrationsControllerGetCompanyRoles }
}